import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';

export const useQueryParameters = (): URLSearchParams => {
  // this hook keeps track of the initial pathname and only updates the
  // search param results if we're on the same path; this update improves the
  // UI when navigating machine files
  const { search, pathname } = useLocation();

  const [initialPath] = useState<string>(pathname);
  const [searchString, setSearchString] = useState<string>(search);

  useEffect(() => {
    if (pathname === initialPath) {
      setSearchString(search);
    }
  }, [initialPath, search, pathname]);

  return useMemo(() => new URLSearchParams(searchString), [searchString]);
};

export const getQueryParameter = (param: string): string | null | undefined => {
  const { search } = window.location;
  const queryParams = new URLSearchParams(search);
  return queryParams.get(param);
};

/**
 * This function is used to extract an id from the path.
 * @param pathPart the path param name preceding the id
 * (ex: machines for machines/<id>)
 * @param backup a backup id to use if the id is not found
 * @returns the id if found, undefined otherwise
 */
export const getPathIdParam = (
  pathPart: string,
  backup?: string
): string | undefined => {
  let id = backup;
  const regex = new RegExp(`(${pathPart}\\/)[\\d\\w-]+`);
  const match = location.pathname.match(regex);
  if (match) {
    id = match[0].split('/')[1];
  }

  return id;
};
